export const UPDATE_DESCBLOCK_DATA = '@ibibo/UPDATE_DESCBLOCK_DATA';
export const UPDATE_DESCBLOCK_INPUT = '@ibibo/UPDATE_DESCBLOCK_INPUT';
export const UPDATE_DESCBLOCK_INPUT_FWD = '@ibibo/UPDATE_DESCBLOCK_INPUT_FWD';
export const UPDATE_TRAVELLER_DETAILS = '@ibibo/UPDATE_TRAVELLER_DETAILS';
export const TOGGLE_TRAVELLER_PROFILE_TYPE = '@ibibo/TOGGLE_TRAVELLER_PROFILE_TYPE';
export const UPDATE_HOTELS_PAYMENTS_DATA = '@ibibo/UPDATE_HOTELS_PAYMENTS_DATA';
export const UPDATE_HOTELS_PAYMENT_OPEN_CLOSE_STATUS =
  '@ibibo/UPDATE_HOTELS_PAYMENT_OPEN_CLOSE_STATUS';
export const UPDATE_USEGOCASH_STATUS = '@ibibo/UPDATE_USEGOCASH_STATUS';
export const RESET_PAYMENTS_DATA = '@ibibo/RESET_PAYMENTS_DATA';
export const UPDATE_DESCBLOCK_LOADING_STATUS = '@ibibo/UPDATE_DESCBLOCK_LOADING_STATUS';
export const UPDATE_EARLYCHECKIN_STATUS = '@ibibo/UPDATE_EARLYCHECKIN_STATUS';
export const UPDATE_COUNTRY_CODES = '@ibibo/UPDATE_COUNTRY_CODES';
export const UPDATE_HOTELS_POLICY = '@ibibo/UPDATE_HOTELS_POLICY';
export const UPDATE_USER_VERIFICATION = 'UPDATE_USER_VERIFICATION';
